export default {
  namespaced: true,
  state: {
    alerts: []
  },
  mutations: {
    add (state, payload) {
      state.alerts.push(payload)
    },
    delete (state, payload) {
      let aux = state.alerts.findIndex(x => x.texto === payload.texto)
      if (aux >= 0) {
        state.alerts.splice(aux, 1)
      }
    }
  },
  actions: {
    add ({commit}, payload) {
      commit('add', payload)
      setTimeout(() => {
        commit('delete', payload)
      }, 5000)
    },
    addNotLoggedIn ({getters, dispatch}) {
      var idioma = localStorage.getItem('i18n')
      if (getters.getAll.filter(x => x.texto === 'Necesita iniciar sesión para acceder a esa página').length === 0) {
        if (idioma == 'es') {
          dispatch('add', { texto: 'Necesita iniciar sesión para acceder a esa página', color: 'error' })
        }
        if (idioma == 'en') {
          dispatch('add', { texto: 'You need to login to access that page', color: 'error' })
        }
        if (idioma == 'eu') {
          dispatch('add', { texto: 'Orrialde horretara sartzeko saioa hasi behar duzu', color: 'error' })
        }
        
      }
    },
    delete ({commit}, payload) {
      commit('delete', payload)
    }
  },
  getters: {
    getAll (state) {
      return state.alerts
    }
  }

}
